import { INSURANCE } from '@/constants';
import { CountryKey, Entity, HomeType } from '@/enums';
import { useLocation } from '@reach/router';

export const getRoute = (pathname: string) => {
  const countryCode =
    Object.values(CountryKey).find((value) => {
      return pathname.includes(value);
    }) ?? CountryKey.MalaysiaUrl;

  const productType =
    Object.values(HomeType).find((value) => {
      return pathname.includes(value);
    }) ?? HomeType.Hohh;

  const entity =
    Object.values(Entity).find((value) => {
      return pathname.includes(value);
    }) ?? Entity.Insurance;

  const page =
    Object.values([
      'quotation',
      'plan',
      'declaration',
      'application',
      'review',
      'payment',
      'error',
      'maintenance',
    ]).find((value) => {
      return pathname.includes(value);
    }) ?? 'quotation';

  return {
    countryCode,
    productType,
    entity,
    page,
  };
};

/**
 * @description returns hohh, myrumah
 */
export function useRouteType() {
  const location = useLocation();
  const { productType } = getRoute(location.pathname);
  return productType;
}

/**
 * @description returns insurance, takaful
 */
export function useRouteSection() {
  const location = useLocation();
  const { entity } = getRoute(location.pathname);
  return entity;
}

/** pages */
export function useRoutePage() {
  const location = useLocation();
  const { page } = getRoute(location.pathname);
  return page;
}

export function getOrigin() {
  const location = useLocation();
  return location.host;
}

export function useInsuranceRoute() {
  const routerSection = useRouteSection();
  return routerSection === INSURANCE;
}
